import { render, staticRenderFns } from "./EventSection.vue?vue&type=template&id=15ca7e36&scoped=true&"
import script from "./EventSection.vue?vue&type=script&lang=ts&"
export * from "./EventSection.vue?vue&type=script&lang=ts&"
import style0 from "./EventSection.vue?vue&type=style&index=0&id=15ca7e36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca7e36",
  null
  
)

export default component.exports